<template>
  <v-container>
    <PageHeader :title="name" />

    <AdministrationContinuousDataStations :name="name" style="padding-top: 10px" />
    <AdministrationDiscreteSampleStations :name="name" style="padding-top: 20px" />
  </v-container>
</template>

<script>
  import AdministrationContinuousDataStations from './AdministrationContinuousDataStations'
  import AdministrationDiscreteSampleStations from './AdministrationDiscreteSampleStations'

  export default {
    components: {
      AdministrationContinuousDataStations,
      AdministrationDiscreteSampleStations,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    mounted() {},
    computed: {},
    methods: {},
  }
</script>

<style scoped>
  .page_title {
    margin-left: 0px !important;
  }
</style>